//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { WeddingPageAPIClientBase } from './WeddingPageAPIClientBase';import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { DateTime, Duration } from "luxon";

export class WeddingPageAPIClient extends WeddingPageAPIClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("http://localhost:7071/api");

    }

    /**
     * @return OK response
     */
    getAllUsers( cancelToken?: CancelToken | undefined): Promise<UserDataExtendedDto[]> {
        let url_ = this.baseUrl + "/GetAllUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUsers(_response);
        });
    }

    protected processGetAllUsers(response: AxiosResponse): Promise<UserDataExtendedDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDataExtendedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserDataExtendedDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDataExtendedDto[]>(null as any);
    }

    /**
     * @return OK response
     */
    isAuthenticated( cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/IsAuthenticated";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsAuthenticated(_response);
        });
    }

    protected processIsAuthenticated(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body Auth Command
     * @return OK response
     */
    authenticate(body: AuthCommand, cancelToken?: CancelToken | undefined): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthResponse.fromJS(resultData200);
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @return OK response
     */
    getGlobalConfigs( cancelToken?: CancelToken | undefined): Promise<GlobalConfigsDto> {
        let url_ = this.baseUrl + "/GetGlobalConfigs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGlobalConfigs(_response);
        });
    }

    protected processGetGlobalConfigs(response: AxiosResponse): Promise<GlobalConfigsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GlobalConfigsDto.fromJS(resultData200);
            return Promise.resolve<GlobalConfigsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GlobalConfigsDto>(null as any);
    }

    /**
     * @return OK response
     */
    getGifts( cancelToken?: CancelToken | undefined): Promise<GiftDataDto[]> {
        let url_ = this.baseUrl + "/GetGifts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGifts(_response);
        });
    }

    protected processGetGifts(response: AxiosResponse): Promise<GiftDataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GiftDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GiftDataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GiftDataDto[]>(null as any);
    }

    /**
     * @param giftId Gift Id
     * @return OK response
     */
    reserveGift(giftId: string, cancelToken?: CancelToken | undefined): Promise<GiftDataDto> {
        let url_ = this.baseUrl + "/ReserveGift?";
        if (giftId === undefined || giftId === null)
            throw new Error("The parameter 'giftId' must be defined and cannot be null.");
        else
            url_ += "GiftId=" + encodeURIComponent("" + giftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReserveGift(_response);
        });
    }

    protected processReserveGift(response: AxiosResponse): Promise<GiftDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GiftDataDto.fromJS(resultData200);
            return Promise.resolve<GiftDataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GiftDataDto>(null as any);
    }

    /**
     * @param giftId Gift Id
     * @return OK response
     */
    releaseGift(giftId: string, cancelToken?: CancelToken | undefined): Promise<GiftDataDto> {
        let url_ = this.baseUrl + "/ReleaseGift?";
        if (giftId === undefined || giftId === null)
            throw new Error("The parameter 'giftId' must be defined and cannot be null.");
        else
            url_ += "GiftId=" + encodeURIComponent("" + giftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReleaseGift(_response);
        });
    }

    protected processReleaseGift(response: AxiosResponse): Promise<GiftDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GiftDataDto.fromJS(resultData200);
            return Promise.resolve<GiftDataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GiftDataDto>(null as any);
    }

    /**
     * @return OK response
     */
    getRSVPStatus( cancelToken?: CancelToken | undefined): Promise<UserDataDto[]> {
        let url_ = this.baseUrl + "/GetRSVPStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRSVPStatus(_response);
        });
    }

    protected processGetRSVPStatus(response: AxiosResponse): Promise<UserDataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserDataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDataDto[]>(null as any);
    }

    /**
     * @param body Set RSVP status for list of users
     * @return OK response
     */
    setRSVPStatus(body: RsvpCommand, cancelToken?: CancelToken | undefined): Promise<UserDataDto[]> {
        let url_ = this.baseUrl + "/SetRSVPStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetRSVPStatus(_response);
        });
    }

    protected processSetRSVPStatus(response: AxiosResponse): Promise<UserDataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserDataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDataDto[]>(null as any);
    }

    /**
     * @return OK response
     */
    getSelf( cancelToken?: CancelToken | undefined): Promise<UserDataDto> {
        let url_ = this.baseUrl + "/GetSelf";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelf(_response);
        });
    }

    protected processGetSelf(response: AxiosResponse): Promise<UserDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDataDto.fromJS(resultData200);
            return Promise.resolve<UserDataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDataDto>(null as any);
    }

    /**
     * @param body Sets new custom password for user
     * @return OK response
     */
    setPassword(body: UserDataUpdateCommand, cancelToken?: CancelToken | undefined): Promise<UserDataDto> {
        let url_ = this.baseUrl + "/SetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetPassword(_response);
        });
    }

    protected processSetPassword(response: AxiosResponse): Promise<UserDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDataDto.fromJS(resultData200);
            return Promise.resolve<UserDataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDataDto>(null as any);
    }
}

export class AuthCommand implements IAuthCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAuthCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AuthCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;
}

export class AuthResponse implements IAuthResponse {
    token?: string | undefined;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IAuthResponse {
    token?: string | undefined;
}

export class GiftDataDto implements IGiftDataDto {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    hyperlink?: string | undefined;
    imageLink?: string | undefined;
    isReservedOther?: boolean | undefined;
    isReservedSelf?: boolean | undefined;

    constructor(data?: IGiftDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.hyperlink = _data["hyperlink"];
            this.imageLink = _data["imageLink"];
            this.isReservedOther = _data["isReservedOther"];
            this.isReservedSelf = _data["isReservedSelf"];
        }
    }

    static fromJS(data: any): GiftDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["hyperlink"] = this.hyperlink;
        data["imageLink"] = this.imageLink;
        data["isReservedOther"] = this.isReservedOther;
        data["isReservedSelf"] = this.isReservedSelf;
        return data;
    }
}

export interface IGiftDataDto {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    hyperlink?: string | undefined;
    imageLink?: string | undefined;
    isReservedOther?: boolean | undefined;
    isReservedSelf?: boolean | undefined;
}

export class GlobalConfigsDto implements IGlobalConfigsDto {
    gallery_GooglePhotosGalleryLink?: string | undefined;
    gifts_ReceiverName1?: string | undefined;
    gifts_ReceiverName2?: string | undefined;
    rsvP_DeadlineDate?: DateTime | undefined;
    gallery_PhotographerGalleryLink?: string | undefined;
    gallery_InstagramGalleryLink?: string | undefined;
    gifts_IBAN?: string | undefined;
    contact1_Phone?: string | undefined;
    contact2_Phone?: string | undefined;
    contact3_Phone?: string | undefined;
    contact4_Phone?: string | undefined;

    constructor(data?: IGlobalConfigsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gallery_GooglePhotosGalleryLink = _data["gallery_GooglePhotosGalleryLink"];
            this.gifts_ReceiverName1 = _data["gifts_ReceiverName1"];
            this.gifts_ReceiverName2 = _data["gifts_ReceiverName2"];
            this.rsvP_DeadlineDate = _data["rsvP_DeadlineDate"] ? DateTime.fromISO(_data["rsvP_DeadlineDate"].toString()) : <any>undefined;
            this.gallery_PhotographerGalleryLink = _data["gallery_PhotographerGalleryLink"];
            this.gallery_InstagramGalleryLink = _data["gallery_InstagramGalleryLink"];
            this.gifts_IBAN = _data["gifts_IBAN"];
            this.contact1_Phone = _data["contact1_Phone"];
            this.contact2_Phone = _data["contact2_Phone"];
            this.contact3_Phone = _data["contact3_Phone"];
            this.contact4_Phone = _data["contact4_Phone"];
        }
    }

    static fromJS(data: any): GlobalConfigsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalConfigsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gallery_GooglePhotosGalleryLink"] = this.gallery_GooglePhotosGalleryLink;
        data["gifts_ReceiverName1"] = this.gifts_ReceiverName1;
        data["gifts_ReceiverName2"] = this.gifts_ReceiverName2;
        data["rsvP_DeadlineDate"] = this.rsvP_DeadlineDate ? this.rsvP_DeadlineDate.toString() : <any>undefined;
        data["gallery_PhotographerGalleryLink"] = this.gallery_PhotographerGalleryLink;
        data["gallery_InstagramGalleryLink"] = this.gallery_InstagramGalleryLink;
        data["gifts_IBAN"] = this.gifts_IBAN;
        data["contact1_Phone"] = this.contact1_Phone;
        data["contact2_Phone"] = this.contact2_Phone;
        data["contact3_Phone"] = this.contact3_Phone;
        data["contact4_Phone"] = this.contact4_Phone;
        return data;
    }
}

export interface IGlobalConfigsDto {
    gallery_GooglePhotosGalleryLink?: string | undefined;
    gifts_ReceiverName1?: string | undefined;
    gifts_ReceiverName2?: string | undefined;
    rsvP_DeadlineDate?: DateTime | undefined;
    gallery_PhotographerGalleryLink?: string | undefined;
    gallery_InstagramGalleryLink?: string | undefined;
    gifts_IBAN?: string | undefined;
    contact1_Phone?: string | undefined;
    contact2_Phone?: string | undefined;
    contact3_Phone?: string | undefined;
    contact4_Phone?: string | undefined;
}

export class RsvpCommand implements IRsvpCommand {
    comments?: string | undefined;
    users?: UserRSVPCommand[] | undefined;

    constructor(data?: IRsvpCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comments = _data["comments"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserRSVPCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RsvpCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RsvpCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comments"] = this.comments;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRsvpCommand {
    comments?: string | undefined;
    users?: UserRSVPCommand[] | undefined;
}

export class UserDataDto implements IUserDataDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    isAttending?: boolean | undefined;
    busToWeddingPlace?: boolean | undefined;
    busToCity?: boolean | undefined;
    specialDiets?: string | undefined;
    groupName?: string | undefined;
    isAdmin?: boolean | undefined;

    constructor(data?: IUserDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.isAttending = _data["isAttending"];
            this.busToWeddingPlace = _data["busToWeddingPlace"];
            this.busToCity = _data["busToCity"];
            this.specialDiets = _data["specialDiets"];
            this.groupName = _data["groupName"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): UserDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["isAttending"] = this.isAttending;
        data["busToWeddingPlace"] = this.busToWeddingPlace;
        data["busToCity"] = this.busToCity;
        data["specialDiets"] = this.specialDiets;
        data["groupName"] = this.groupName;
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface IUserDataDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    isAttending?: boolean | undefined;
    busToWeddingPlace?: boolean | undefined;
    busToCity?: boolean | undefined;
    specialDiets?: string | undefined;
    groupName?: string | undefined;
    isAdmin?: boolean | undefined;
}

export class UserDataExtendedDto implements IUserDataExtendedDto {
    lastEditedByUser?: string | undefined;
    lastEditedTime?: DateTime | undefined;
    lastLoginTime?: DateTime | undefined;
    loginCount?: number | undefined;
    lastPageVisitTime?: DateTime | undefined;
    pageVisitCount?: number | undefined;
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    isAttending?: boolean | undefined;
    busToWeddingPlace?: boolean | undefined;
    busToCity?: boolean | undefined;
    specialDiets?: string | undefined;
    groupName?: string | undefined;
    isAdmin?: boolean | undefined;

    constructor(data?: IUserDataExtendedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastEditedByUser = _data["lastEditedByUser"];
            this.lastEditedTime = _data["lastEditedTime"] ? DateTime.fromISO(_data["lastEditedTime"].toString()) : <any>undefined;
            this.lastLoginTime = _data["lastLoginTime"] ? DateTime.fromISO(_data["lastLoginTime"].toString()) : <any>undefined;
            this.loginCount = _data["loginCount"];
            this.lastPageVisitTime = _data["lastPageVisitTime"] ? DateTime.fromISO(_data["lastPageVisitTime"].toString()) : <any>undefined;
            this.pageVisitCount = _data["pageVisitCount"];
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.isAttending = _data["isAttending"];
            this.busToWeddingPlace = _data["busToWeddingPlace"];
            this.busToCity = _data["busToCity"];
            this.specialDiets = _data["specialDiets"];
            this.groupName = _data["groupName"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): UserDataExtendedDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataExtendedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastEditedByUser"] = this.lastEditedByUser;
        data["lastEditedTime"] = this.lastEditedTime ? this.lastEditedTime.toString() : <any>undefined;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toString() : <any>undefined;
        data["loginCount"] = this.loginCount;
        data["lastPageVisitTime"] = this.lastPageVisitTime ? this.lastPageVisitTime.toString() : <any>undefined;
        data["pageVisitCount"] = this.pageVisitCount;
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["isAttending"] = this.isAttending;
        data["busToWeddingPlace"] = this.busToWeddingPlace;
        data["busToCity"] = this.busToCity;
        data["specialDiets"] = this.specialDiets;
        data["groupName"] = this.groupName;
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface IUserDataExtendedDto {
    lastEditedByUser?: string | undefined;
    lastEditedTime?: DateTime | undefined;
    lastLoginTime?: DateTime | undefined;
    loginCount?: number | undefined;
    lastPageVisitTime?: DateTime | undefined;
    pageVisitCount?: number | undefined;
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    isAttending?: boolean | undefined;
    busToWeddingPlace?: boolean | undefined;
    busToCity?: boolean | undefined;
    specialDiets?: string | undefined;
    groupName?: string | undefined;
    isAdmin?: boolean | undefined;
}

export class UserDataUpdateCommand implements IUserDataUpdateCommand {
    password?: string | undefined;

    constructor(data?: IUserDataUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserDataUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserDataUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        return data;
    }
}

export interface IUserDataUpdateCommand {
    password?: string | undefined;
}

export class UserRSVPCommand implements IUserRSVPCommand {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isAttending?: boolean | undefined;
    busToCity?: boolean | undefined;
    busToWeddingPlace?: boolean | undefined;
    specialDiets?: string | undefined;

    constructor(data?: IUserRSVPCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isAttending = _data["isAttending"];
            this.busToCity = _data["busToCity"];
            this.busToWeddingPlace = _data["busToWeddingPlace"];
            this.specialDiets = _data["specialDiets"];
        }
    }

    static fromJS(data: any): UserRSVPCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserRSVPCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isAttending"] = this.isAttending;
        data["busToCity"] = this.busToCity;
        data["busToWeddingPlace"] = this.busToWeddingPlace;
        data["specialDiets"] = this.specialDiets;
        return data;
    }
}

export interface IUserRSVPCommand {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isAttending?: boolean | undefined;
    busToCity?: boolean | undefined;
    busToWeddingPlace?: boolean | undefined;
    specialDiets?: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
